export default __webpack_public_path__ + "static/parrot-00f253ed8c44f35f3844a2ef3ddbaffd.png";